import { useForm } from "react-hook-form";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";

import FormContainer from "../../../../../../common/components/form_container";

import { GetObraServicosControladosDropDown } from "../../../../data/daos/read/get_obra_servicos_controlados_dropdown";
import {
  ObrasServicosControladosForm,
  ObrasServicosControladosSchema,
} from "../../../schemas/Obras_ObrasServicosControlados/Obras_ObrasServicosControlados";

/**
 * ObrasServicosControladosModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  servicoscontrolados: GetObraServicosControladosDropDown[];
  onClose: () => void;
  onSubmit: (form: ObrasServicosControladosForm) => void;
};

export const ObrasServicosControladosModal = ({ open, saving, loading, servicoscontrolados, onClose, onSubmit }: Props) => {
  const hookForm = useForm<ObrasServicosControladosForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(ObrasServicosControladosSchema),
  });

  useEffect(() => {
    if (open) {
      hookForm.reset();
    }
  }, [open, hookForm]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      width="50rem"
      title="Incluir Serviços Controlados"
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}
    >
      <FormContainer title="Informações" arrangement="fullRow">
        <>
          <DefaultFormMultiAutocomplete
            name="idServicosControlados"
            label="Serviços Controlados"
            options={servicoscontrolados}
            getOptionKey={(x) => x.idServicosControlados}
            getOptionLabel={(x) => x.servicosControlados ?? ""}
            reactHookForm={hookForm}
          />
        </>
      </FormContainer>
    </BaseFormControlledModal>
  );
};
